function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "PO_Incoming",
  "data-name": "PO Incoming",
  transform: "translate(-1141.802 -238.015)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bill",
  transform: "translate(1149 238)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M1.181,1.184h.024a.277.277,0,0,0,.04,0,.668.668,0,0,1,.637.683.291.291,0,1,0,.582,0A1.284,1.284,0,0,0,1.5.6V.306A.3.3,0,0,0,1.205,0,.3.3,0,0,0,.914.306V.614a1.3,1.3,0,0,0-.9,1.42A1.255,1.255,0,0,0,1.232,3.16a.684.684,0,0,1,0,1.367.667.667,0,0,1-.65-.683.3.3,0,0,0-.291-.306A.3.3,0,0,0,0,3.843,1.288,1.288,0,0,0,.914,5.095V5.43a.3.3,0,0,0,.291.306A.3.3,0,0,0,1.5,5.43V5.109a1.29,1.29,0,0,0,.961-1.4A1.256,1.256,0,0,0,1.232,2.548a.666.666,0,0,1-.65-.656.672.672,0,0,1,.6-.708Z",
  transform: "translate(12.583 1.511)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M11.169,17.977H2.183v-.006A2.351,2.351,0,0,1,0,15.576V14.215a.292.292,0,0,1,.3-.292H2.358L2.426,3.191a.312.312,0,0,1,.291-.319H9.941A4.18,4.18,0,0,1,13.832,0a4.248,4.248,0,0,1,4.132,4.347,4.249,4.249,0,0,1-4.133,4.348c-.072,0-.148,0-.225-.007v6.886a2.35,2.35,0,0,1-2.282,2.4h-.006c-.024,0-.043,0-.066,0l-.082-.005v.009ZM9.336,13.923h0a.263.263,0,0,1,.19.082.294.294,0,0,1,.078.21v1.355a1.767,1.767,0,0,0,1.714,1.795h.005a1.752,1.752,0,0,0,1.7-1.791V8.611A4.128,4.128,0,0,1,10.367,6.7H7.3a.306.306,0,0,1,0-.612h2.749A4.483,4.483,0,0,1,9.7,4.333a4.9,4.9,0,0,1,.08-.85H3.007L2.939,13.923h6.4Zm-8.754.611v1.039a1.759,1.759,0,0,0,1.709,1.791H9.8a.527.527,0,0,0-.059-.057c-.015-.012-.029-.025-.041-.038a2.48,2.48,0,0,1-.673-1.7V14.534ZM13.832.62a3.648,3.648,0,0,0-3.55,3.731,3.648,3.648,0,0,0,3.55,3.731,3.654,3.654,0,0,0,3.55-3.731A3.648,3.648,0,0,0,13.832.62Z",
  transform: "translate(0 0.015)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2ZM1,.645A.366.366,0,0,0,.625,1,.366.366,0,0,0,1,1.355.366.366,0,0,0,1.375,1,.366.366,0,0,0,1,.645Z",
  transform: "translate(4.502 8.135)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M0,.306A.3.3,0,0,0,.291.612h3.88A.3.3,0,0,0,4.462.306.3.3,0,0,0,4.171,0H.291A.3.3,0,0,0,0,.306Z",
  transform: "translate(7.011 8.776)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-3",
  "data-name": "Shape",
  d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2ZM1,.645A.366.366,0,0,0,.625,1,.366.366,0,0,0,1,1.355.366.366,0,0,0,1.375,1,.366.366,0,0,0,1,.645Z",
  transform: "translate(4.502 5.476)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-4",
  "data-name": "Shape",
  d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2ZM1,.645A.366.366,0,0,0,.625,1,.366.366,0,0,0,1,1.355.366.366,0,0,0,1.375,1,.366.366,0,0,0,1,.645Z",
  transform: "translate(4.502 10.794)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M4.171,0H.291A.3.3,0,0,0,0,.306.3.3,0,0,0,.291.612h3.88A.3.3,0,0,0,4.462.306.3.3,0,0,0,4.171,0Z",
  transform: "translate(7.011 11.452)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_272",
  "data-name": "Path 272",
  d: "M7.043,8.64a.486.486,0,0,1-.359.14.491.491,0,0,1-.5-.491l-.07-1.53H0V2.006H6.113L6.128.5a.5.5,0,0,1,.5-.5A.586.586,0,0,1,7,.155l4.982,3.82a.464.464,0,0,1,.141.343.485.485,0,0,1-.141.359L7.262,8.469Z",
  transform: "translate(1142.202 240)",
  fill: "#222",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.8
}));

var SvgPurchaseOrderIncoming = function SvgPurchaseOrderIncoming(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.162,
    height: 17.977,
    viewBox: "0 0 25.162 17.977",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurchaseOrderIncoming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purchaseOrderIncoming.1887aaef.svg";
export { ForwardRef as ReactComponent };